/* BRINUTI – régi Teeinblue-rétegek cseréje a termékoldali galériában
   (2026-10-30, a tulaj kérése: a napló gumipánt és belső zseb nélkül készül).
   Adat: snippets/brinuti-ujreteg.liquid (#brinuti-ujreteg-adat): régi réteg-
   azonosító → a téma javított képe. A 12 saját réteges borítót a
   brinuti-mockup-javitas.js kezeli: ahol az fut, a közös „ima_viragos”
   réteget (261012_PzObsxzbegX025I6) itt nem cseréljük. */
(function () {
  var elem = document.getElementById('brinuti-ujreteg-adat');
  if (!elem) return;
  var terkep;
  try { terkep = JSON.parse(elem.textContent); } catch (e) { return; }
  if (document.getElementById('brinuti-mockup-adat')) delete terkep['261012_PzObsxzbegX025I6'];
  var elonezet = {};
  try { elonezet = JSON.parse((document.getElementById('brinuti-ujreteg-elonezet') || {}).textContent || '{}'); } catch (e) {}
  var kepMinta = /campaign-products\/\d+\/([A-Za-z0-9_]+?)(?:_thumbnail)?\.webp/;
  var minta = /mockup-layers\/([A-Za-z0-9_]+?)(?:_large|_master_large|_thumbnail)?\.(?:webp|png|jpe?g)/;

  function cserel(img) {
    var src = img.getAttribute('src') || '';
    var t = minta.exec(src), uj = t && terkep[t[1]];
    if (!uj) {
      var k = kepMinta.exec(src);
      uj = k && elonezet[k[1]] && terkep[elonezet[k[1]]];
    }
    if (!uj) return;
    if (src === uj) return;
    img.removeAttribute('srcset');
    img.setAttribute('src', uj);
  }
  function atnez(cs) {
    if (cs.nodeType !== 1) return;
    if (cs.tagName === 'IMG') cserel(cs);
    var k = cs.querySelectorAll ? cs.querySelectorAll('img') : [];
    for (var i = 0; i < k.length; i++) cserel(k[i]);
  }
  atnez(document.documentElement);
  new MutationObserver(function (lista) {
    for (var i = 0; i < lista.length; i++) {
      var m = lista[i];
      if (m.type === 'attributes') cserel(m.target);
      else for (var j = 0; j < m.addedNodes.length; j++) atnez(m.addedNodes[j]);
    }
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });
})();

/* Teeinblue-leírás szállítási mondata (2026-10-30, a tulaj kérése: az éjfélig
   beérkező rendelést a 2. munkanapon gyártjuk és adjuk át a GLS-nek). A
   Shopify-termékleírás már új, de a Teeinblue-űrlap a kampány saját (régi)
   leírását rajzolja ki, ezért itt cseréljük, amíg a kampányokban is át nem írják. */
(function () {
  var REGI = 'Kézzel kötjük neked és másnap postára adjuk!';
  var UJ = 'Kézzel kötjük neked, és a 2. munkanapon postára adjuk!';
  function javit(gyoker) {
    if (!gyoker || gyoker.nodeType !== 1 || (gyoker.textContent || '').indexOf('másnap postára') === -1) return;
    var jaro = document.createTreeWalker(gyoker, NodeFilter.SHOW_TEXT, null), n;
    while ((n = jaro.nextNode())) {
      if (n.nodeValue.indexOf(REGI) !== -1) n.nodeValue = n.nodeValue.split(REGI).join(UJ);
    }
  }
  javit(document.body);
  new MutationObserver(function (lista) {
    for (var i = 0; i < lista.length; i++) {
      var m = lista[i];
      if (m.type === 'characterData') javit(m.target.parentNode);
      else for (var j = 0; j < m.addedNodes.length; j++) {
        var c = m.addedNodes[j];
        javit(c.nodeType === 3 ? c.parentNode : c);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();
